import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../theme/customColors";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "485px",
  },
  titleStyles: {
    fontWeight: 700,
    fontSize: "18px",
    marginBottom: theme.spacing(2),
  },
  section: {
    fontSize: "16px",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  description: {
    fontSize: "14px",
    marginBottom: theme.spacing(3),
  },
  label: {
    fontSize: "12px",
    lineHeight: "14px",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  inputStyle: {
    minWidth: theme.spacing(30),
  },
  buttonContainer: {
    marginTop: theme.spacing(4),
  },
  buttonSpacing: {
    marginRight: theme.spacing(1),
  },
  linkContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
    maxWidth: "fit-content",
    marginTop: theme.spacing(3),
  },
  linkStyle: {
    marginRight: theme.spacing(1.5),
    color: secondary,
  },
}));

export default useStyles;
